import getRuleError from "../utils/getRuleError";
import getRuleValue from "../utils/getRuleValue";
import {translate} from "../../../../i18n";
import getRequiredError from "../utils/getRequiredError";
import text from "./text";
import number from "./number";

let $value, $rules, $options, $allValues;

export default function (value, rules, options, allValues) {
    $value = value;
    $rules = rules;
    $options = options;
    $allValues = allValues;

    return checkRequired() || checkMinTags() || checkMaxTags() || checkEachTag();
}

function checkRequired() {
    if ($value.length > 0) {
        return null;
    }

    return getRequiredError($rules, $options, $allValues);
}

function checkMinTags() {
    const {minTags} = $rules;

    if (minTags === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(minTags, $allValues);

    if ($value.length >= ruleValue) {
        return null;
    }

    return getRuleError(minTags, $allValues, translate('min_tags{number}', {number: ruleValue}));
}

function checkMaxTags() {
    const {maxTags} = $rules;

    if (maxTags === undefined) {
        return null;
    }

    const ruleValue = getRuleValue(maxTags, $allValues);

    if ($value.length <= ruleValue) {
        return null;
    }

    return getRuleError(maxTags, $allValues, translate('max_tags{number}', {number: ruleValue}));
}

function checkEachTag() {
    const {eachTag} = $rules;

    const ruleValue = getRuleValue(eachTag, $allValues);

    if (ruleValue === undefined) {
        return null;
    }

    const errorsOfEachTags = getErrorsOfEachTags(ruleValue);

    if (errorsOfEachTags.length === 0) {
        return null;
    }

    return getRuleError(eachTag, [$allValues, {errorsOfEachTags}], translate('::errors', {errors: errorsOfEachTags}));
}

function getErrorsOfEachTags(ruleValue) {
    switch (ruleValue.type) {
        case 'text':
            return $value.reduce((errors, eachValue) => {
                const error = text(eachValue, ruleValue.rules || {}, ruleValue.options || {}, $allValues);
                if (error && !errors.includes(error)) {
                    errors.push(error);
                }
                return errors;
            }, []);
        case 'number':
            return $value.reduce((errors, eachValue) => {
                const error = number(eachValue, ruleValue.rules || {}, ruleValue.options || {}, $allValues);
                if (error && !errors.includes(error)) {
                    errors.push(error);
                }
                return errors;
            }, []);
    }

    return [];
}

function checkPillboxTagError(tagValue, rule, allValues) {
    const ruleValue = getRuleValue(rule, allValues);

    if (ruleValue === undefined) {
        return null;
    }

    if (ruleValue.type === 'text') {
        return text(tagValue, ruleValue.rules || {}, ruleValue.options || {}, allValues);
    }

    if (ruleValue.type === 'number') {
        return number(tagValue, ruleValue.rules || {}, ruleValue.options || {}, allValues);
    }

    return null;
}

export {
    checkPillboxTagError
}
